<template>
	<div>
		<!-- Service Fees -->
		<br><br><br>
		<h1>WRKPRTY Service Fees</h1>
		<p>To operate the WRKPRTY Platform, we charge various service fees.</p>
		<p><strong>Host service fees</strong></p>
		<p>We charge hosts a 15% service fee (including taxes, if applicable). The amount of the host service fee is calculated from the price that hosts set for their Host Services. You will see the host service fee when you set your price before submitting a listing. The host service fee is automatically deducted from the payout to the Host.</p>
		<p><strong>Guest service fees</strong></p>
		<p>Depending on Membership level we may charge Guests a service a flat fee of $5 - $15 or a percentage based fee of between 5% and 15% of the reservation subtotal, when the booking request is confirmed. Guests see any fees that will be applied on the checkout confirmation page before completing the booking request process.</p>
		<p>You shall be solely responsible for payment to WRKPRTY of all such Service Fees incurred by you through your use of the WRKPRTY Platform. We reserve the right to adjust the Service Fees at any time.</p>
	</div>
</template>

<script>
export default {
	props: {
		changepage: {
			type: Function,
			required: true
		}
	}
}
</script>
